module.exports = __webpack_public_path__ + "img/2.e728752f.png";